import { ReactElement, useState, useEffect } from 'react';
import { Accordion } from '../../components/Accordion/Accordion';
import { Cpf, Phone } from '../../utils/masks';
import {
  Title,
  HelpContent,
  HelpContenSidebar,
  HelpContentMain,
  TextWrapper,
  Text,
  TextArea,
  AccordionWrapper
} from './styles';

import { useSelector, useDispatch } from 'react-redux';

import { sendMail } from '../../utils/services';

import {
  ScheduleRootState,
  Item,
  FILTER,
  SET_LOAD,
  UserInfo
} from '../../store/redux';

import ButtonLocal from '../../ui/Button';

import Load from '../../ui/SimpleLoad';
import ButtonWhatsapp from '../../ui/ButtonWhatsapp';

function getFieldClassName(hasError: boolean, isEmpty: boolean): string {
  return hasError && isEmpty ? 'form-control required' : 'form-control';
}

export default function Contact(): ReactElement {
  const dispatch = useDispatch();
  const accordionItems = useSelector<ScheduleRootState, Item[] | undefined>(scheduleReducer => scheduleReducer.filtered);
  const userInfo: UserInfo = (useSelector<ScheduleRootState, UserInfo>(scheduleReducer => scheduleReducer.user));

  const [search, setSearch] = useState('');

  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [erros, setErros] = useState<any>({});
  const [responseMessage, setResponseMessage] = useState('');

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [cpf, setCpf] = useState('');
  const [message, setMessage] = useState('');

  dispatch({ type: SET_LOAD, load: false });
  useEffect(() => {
    setName(`${userInfo.firstName} ${userInfo.lastName}`);
    setPhone(userInfo?.phone ?? '');
    setEmail(userInfo?.email ?? '');
    setCpf(Cpf(userInfo?.document ?? ''));
  }, [userInfo]);

  useEffect(() => {
    const debounceSearch = setTimeout(
      () => {
        dispatch({ type: FILTER, search: search });
      },
      500
    );
    return () => {
      clearTimeout(debounceSearch);
    };
  }, [search]);

  function validateForm(): { isValid: boolean, fieldErrors?: Record<string, boolean>, errorMessage?: string } {
    if (!name || !phone || !email || !cpf || !message) {
      return {
        isValid: false,
        fieldErrors: { name: !name, phone: !phone, email: !email, cpf: !cpf, message: !message },
        errorMessage: 'Preencha os campos em vermelho:'
      };
    }
    if (cpf.length < 12) {
      return {
        isValid: false,
        errorMessage: 'CPF inválido'
      };
    }
    return { isValid: true };
  }

  async function handleSend(): Promise<any> {
    const { isValid, fieldErrors, errorMessage } = validateForm();
    if (!isValid) {
      setErro(errorMessage ?? '');
      if (fieldErrors) {
        setErros(fieldErrors);
      }
      return;
    }

    setLoading(true);
    const data = {
      nome: name,
      mail: email,
      telefone: phone.replaceAll(/[^\d]+/g, ''),
      cpf: cpf.replaceAll(/[^\d]+/g, ''),
      mensagem: message
    };
    const sendMailResponse = await sendMail(data);
    if (sendMailResponse.statusCode === 400) {
      setErro(sendMailResponse.response);
    } else {
      setResponseMessage('Sua mensagem foi enviada com sucesso');
      setName('');
      setPhone('');
      setEmail('');
      setCpf('');
      setMessage('');
    }
    setLoading(false);
  }
  return (
    <HelpContent>
      <Title>
        <h2>Contato e ajuda</h2>
      </Title>
      <HelpContentMain>
        <TextWrapper>
          <Text>
            <h1>Têm alguma dúvida?</h1>
            <p>
              Se não encontrar o que procura no <strong>Dúvidas Frequentes,</strong> utilize o <strong>Chat</strong> e fale com a gente!
            </p>
          </Text>
        </TextWrapper>
        <input placeholder="Buscar" value={search} onChange={(e) => setSearch(e.target.value)} />
        <AccordionWrapper>
          {
          accordionItems?.length
            ? accordionItems.map((item) => {
              return (
                <Accordion key={item.title}
                  title={item.title}
                >
                  <div dangerouslySetInnerHTML={{ __html: item.content }} />
                </Accordion>
              );
            })
            : <div className="span">Nenhum resultado encontrado...</div>
          }
        </AccordionWrapper>
      </HelpContentMain>

      <HelpContenSidebar>
        <p>
          Contate nosso time
        </p>

        {loading
          ? (
            <Load />
            )
          : (
            <>
            {erro && (
              <p className="error">{erro}</p>
            )}
            {responseMessage && (
              <p className="success">{responseMessage}</p>
            )}
            <div className="form-group">
              <input id="contact-name" className={ getFieldClassName(erros.name, name === '') } value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome" />
              <label htmlFor="contact-name" className="form-label">Nome</label>
            </div>
            <div className="form-group">
              <input id="contact-phone" className={ getFieldClassName(erros.phone, phone === '') } value={phone} onChange={(e) => setPhone(Phone(e.target.value))} placeholder="DDD + Telefone" />
              <label htmlFor="contact-phone" className="form-label">DDD + Telefone</label>
            </div>
            <div className="form-group">
              <input id="contact-email" className={ getFieldClassName(erros.email, email === '') } value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-mail" />
              <label htmlFor="contact-email" className="form-label">E-mail</label>
            </div>
            <div className="form-group">
              <input id="contact-cpf" className={ getFieldClassName(erros.cpf, cpf === '') } value={cpf} onChange={(e) => setCpf(Cpf(e.target.value))} placeholder="CPF" />
              <label htmlFor="contact-cpf" className="form-label">CPF</label>
            </div>
            <TextArea className={ erros.message && message === '' ? 'required' : ''} placeholder="Mensagem" value={message} onChange={(e) => setMessage(e.target.value)} />
           <ButtonLocal
              onClick={ async () => handleSend() }
              bkColor="white"
              border="solid 1px #009DFF"
              color="#009DFF" width={300}
              height={50} fontWeight="700"
              fontSize="14px"
            >
              Enviar
            </ButtonLocal>
            </>
            )
        }
      </HelpContenSidebar>
      <ButtonWhatsapp phone="551136202550" mobileBottom="75" />
    </HelpContent>
  );
}
